// extracted by mini-css-extract-plugin
export default {"main":"MainLayout_main__-IY+v","mainMobile":"MainLayout_mainMobile__DUdNT","container":"MainLayout_container__gh5R8"};